import { useId, type CSSProperties } from "react";

interface RangeProps {
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (v: number) => void;
  label: string;
  display: string;
  lo?: string;
  hi?: string;
}

/** Nordisk Ro range slider with a filled track + mono value chip. */
export default function Range({ min, max, step, value, onChange, label, display, lo, hi }: RangeProps) {
  const id = useId();
  const p = ((value - min) / (max - min)) * 100;
  return (
    <div className="my-6">
      <div className="mb-3 flex items-baseline justify-between gap-3">
        <label htmlFor={id} className="font-ui text-base font-semibold">{label}</label>
        <span className="chip">{display}</span>
      </div>
      <input
        id={id}
        type="range"
        className="range"
        aria-valuetext={display}
        min={min}
        max={max}
        step={step}
        value={value}
        style={{ "--p": `${p}%` } as CSSProperties}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      {(lo || hi) && (
        <div className="mt-2 flex justify-between font-mono text-[11px] text-ink-faint">
          <span>{lo}</span>
          <span>{hi}</span>
        </div>
      )}
    </div>
  );
}
